import { Component, Prop, Vue } from "vue-facing-decorator";
import ImageSpinner from "../components/image_spinner.vue";
import { __vueEvent } from "../constant";
import { EVENTS } from "../enums/events";
import { ActionHandler } from "../helpers/action_handler";
import { isFirefox } from "../helpers/get-browser-type";
import { isSvgImage } from "../helpers/get-image-type-from-url";
import type { MessageStructureComponent, MessageContentSettings } from "../types";

@Component({
	components: { ImageSpinner },
})
export default class Img extends Vue {
	//#region Component Props

	@Prop() component?: MessageStructureComponent;
	isLoaded = false;
    @Prop({
      type: Object,
      default() {
        return {};
      },
    })
    structureSettings?: any;
	//#endregion

	//#region Computed Properties

	get prefixClassName() {
		return this.$store.state.prefixClassName || "";
	}
	get enableMessageNavigation() {
		return this.$store.state.enableMessageNavigation || false;
	}

	//#endregion

	onElClick() {
      
       let isClicked = true;
      try	{
				if (
				this.structureSettings != null &&
				Object.keys(this.structureSettings).length !== 0 &&
				typeof this.structureSettings.hideNavigationImageOnSend !== "undefined"
			) {
				isClicked = this.structureSettings.hideNavigationImageOnSend;
			}
			} catch(ex){}
		ActionHandler.handleBtnClickAction(this.component, {}, isClicked);
	}

	/**
	 * SD-1706
	 * Check if the image has been fully loaded
	 */
	onImgLoad() {
		// Emit a event here, so that we can listen to it at chat bubble
		__vueEvent.emit(EVENTS.ChatBubbleImageLoaded);
		this.isLoaded = true;
	}

	/**
	 * JIRA: SD-5252
	 * Checks if the current browser is Firefox and the component's image URL is an SVG image.
	 * @returns {boolean} True if the browser is Firefox and the image URL is an SVG image, false otherwise.
	 */
	get isFirefoxSVGClass(): boolean {
		try {
			return this.component && isFirefox() && isSvgImage(this.component.imageUrl || "");
		} catch (ex) {
			return false;
		}
	}
}
